"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("reflect-metadata");

var MetaDataKey_1 = require("./MetaDataKey");

var ClassTypeDefinition =
/** @class */
function () {
  function ClassTypeDefinition(options) {
    this.options = options;

    if (options & ClassTypeOptions.AddUnknownFields && options & ClassTypeOptions.DenyUnknownFields) {
      throw new TypeError('AddUnknownFields and DenyUnknownFields must not be used together');
    }
  }

  ClassTypeDefinition.fromObject = function (instanceOrClass) {
    if (typeof instanceOrClass === 'function' && typeof instanceOrClass.prototype !== 'undefined') {
      return Reflect.getMetadata(MetaDataKey_1.metadataKey, instanceOrClass.prototype);
    }

    return Reflect.getMetadata(MetaDataKey_1.metadataKey, instanceOrClass);
  };

  ClassTypeDefinition.prototype.denyUnknownFields = function () {
    return (this.options & ClassTypeOptions.DenyUnknownFields) > 0;
  };

  ClassTypeDefinition.prototype.addUnknownFields = function () {
    return (this.options & ClassTypeOptions.AddUnknownFields) > 0;
  };

  ClassTypeDefinition.prototype.ignoreUnknownFields = function () {
    return this.options === ClassTypeOptions.None || !this.denyUnknownFields() && !this.addUnknownFields();
  };

  return ClassTypeDefinition;
}();

exports.ClassTypeDefinition = ClassTypeDefinition;
var ClassTypeOptions;

(function (ClassTypeOptions) {
  ClassTypeOptions[ClassTypeOptions["None"] = 0] = "None";
  ClassTypeOptions[ClassTypeOptions["DenyUnknownFields"] = 1] = "DenyUnknownFields";
  ClassTypeOptions[ClassTypeOptions["AddUnknownFields"] = 2] = "AddUnknownFields";
})(ClassTypeOptions = exports.ClassTypeOptions || (exports.ClassTypeOptions = {}));

function ra(options) {
  if (options === void 0) {
    options = ClassTypeOptions.None;
  }

  return function (target) {
    Reflect.defineMetadata(MetaDataKey_1.metadataKey, new ClassTypeDefinition(options), target.prototype);
  };
}

exports.ra = ra;